@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.playbook-card {
  background-color: var(--white);
  border-radius: 8px;
  padding: @space-16;
  width: 391px;
  border: 1px solid var(--grey-200);

  @media @desktop {
    width: 309px;
  }

  @media @tablet, @mobile {
    width: 336px;
  }
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.action {
  margin-top: auto;
  width: fit-content;
  font-weight: 600;
}

.header {
  height: 120px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: @space-16;
    inset: 0;
    background-image: url('./header-bg.svg');
    background-size: 360px 120px;
    background-repeat: no-repeat;
  }

  .glyph {
    background-color: var(--green-D8FFEB);
    position: relative;
    z-index: 1;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    padding: @space-4;
    top: @space-12;
    left: @space-12;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
